/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Staging_WarnInputs */

const cs_property_ai_staging_warn = /** @type {(inputs: Property_Ai_Staging_WarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portály mohou zakazovat neuvedený AI staging. Virtuální staging uveďte, kde je to vyžadováno.`)
};

const en_property_ai_staging_warn = /** @type {(inputs: Property_Ai_Staging_WarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portals may forbid undisclosed AI staging. Disclose virtual staging where required.`)
};

/**
* | output |
* | --- |
* | "Portals may forbid undisclosed AI staging. Disclose virtual staging where required." |
*
* @param {Property_Ai_Staging_WarnInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_staging_warn = /** @type {((inputs?: Property_Ai_Staging_WarnInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Staging_WarnInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_staging_warn(inputs)
	return cs_property_ai_staging_warn(inputs)
});